module.exports = __webpack_public_path__ + "static/media/innoedu3.675c7980.png";